/* LLS PDP hero buy box logic. Moved out of sections/lls-product-hero.liquid 2026-11-03 (page weight) so it is
   cached across every product page; the per-product Liquid values come from window.LLS_HERO, printed inline
   by the section just before this file loads (synchronously, at the same spot, so script order is unchanged). */
document.addEventListener('DOMContentLoaded', function() {
  /* ── Config from Liquid ── */
  var C = window.LLS_HERO || {};
  var basePriceCents = C.basePriceCents;
  var basePrice = basePriceCents / 100;
  var servings = C.servings;
  var monthsPerTub = C.monthsPerTub;
  var currencySymbol = C.currencySymbol; /* active market currency (USD on .com), not hardcoded GBP */
  var isBundle = C.isBundle;
  var unitLabel = isBundle ? 'pack' : 'tub';

  /* Ladder data from Liquid: cadence (months) -> selling plan + first/final discount */
  var ladderEl = document.getElementById('lls-ladder-data');
  var ladderData = { cadences: [], mid: 15, monthsPerTub: monthsPerTub };
  if (ladderEl) { try { ladderData = JSON.parse(ladderEl.textContent); } catch (e) {} }
  var unitLabelPlural = isBundle ? 'packs' : 'tubs';
  /* Prepaid 3-pack: one charge covers 3 deliveries at 20% flat (quantity stays 1; the plan carries the schedule). DEFAULT selection when available. */
  var prepaidData = ladderData.prepaid || null;
  var prepaidOn = !!prepaidData; /* 2026-09-23 (Ben): 3-pack back to first + pre-selected (the 9/03 single-first test moved the mix to singles without cutting accidental subs). */
  /* Bulk mode (2026-08): the "prepaid" slot actually carries the LLS 3-Pack Bulk plan (normal
     percentage plan, 3 tubs in one delivery, cart qty 3). All price maths are identical
     (per = unit x 0.8, total = 3x); only cart quantity and delivery copy differ. */
  var bulkMode = !!ladderData.bulkMode;

  /* ── Product Variants JSON (for variant switching) ── */
  /* prepaid is resolved PER VARIANT from its own selling_plan_allocations: Loop creates one
     fixed-price "Prepaid 3-Pack" group per variant on multi-variant products, so a product-level
     group lookup hands variant B's plan id to variant A and Shopify 422s the add. */
  var productVariants = C.variants || [];
  var productOptions = C.options;

  /* ── State ── */
  var mode = ladderData.cadences.length ? 'sub' : 'onetime'; /* 'sub' or 'onetime' */
  var qty = 1;             /* number of adults using the product, 1 or 2 (SUBSCRIBE quantity) */
  var qtyOt = 1;           /* one-time purchase quantity, 1-10 (stepper in the One Time card) */
  var compQtyOt = 1;       /* complement quantity in one-time mode, 1-10 (mini stepper in the routine row) */
  var cad = 0;             /* delivery cadence in months: fixed, supply-matched (no customer choice) */

  /* ── Elements ── */
  var subCards = document.querySelectorAll('.lls-m-sub-card');
  var subscribeCard = document.getElementById('lls-subscribe-card');
  var oneTimeCard = document.getElementById('lls-onetime-link'); /* one-time is now a text link above the CTA */
  var adultsPills = document.querySelectorAll('.lls-m-qpill[data-adults]');
  var deliveryLine = document.getElementById('lls-delivery-line');
  var otStepper = oneTimeCard ? oneTimeCard.querySelector('[data-role="ot-stepper"]') : null;
  var otQtyVal = otStepper ? otStepper.querySelector('[data-role="ot-qty"]') : null;
  var accPre = document.getElementById('lls-acc-pre');
  var accLad = document.getElementById('lls-acc-lad');

  /* ── Ladder helpers ── */
  function cadObj(m) {
    for (var i = 0; i < ladderData.cadences.length; i++) {
      if (ladderData.cadences[i].m === m) return ladderData.cadences[i];
    }
    return null;
  }
  function matchedCad() {
    /* Fixed supply-matched cadence: months_per_tub (guarded to min 1), rounded down to the nearest available; if none at/below, the smallest available. Two adults consume 2 units in one unit's supply period, so the cadence does not change with adults. */
    var target = Math.min(4, Math.max(1, ladderData.monthsPerTub || 1));
    var pick = 0, smallest = 0;
    for (var i = 0; i < ladderData.cadences.length; i++) {
      var m = ladderData.cadences[i].m;
      if (!smallest || m < smallest) smallest = m;
      if (m <= target && m > pick) pick = m;
    }
    return pick || smallest;
  }
  cad = matchedCad();

  /* ── Complete-your-routine complement (optional cross-sell) ── */
  var routineEl = document.getElementById('lls-routine');
  var routineToggle = document.getElementById('lls-routine-toggle');
  var routinePriceEl = document.getElementById('lls-routine-price');
  var routineWasEl = document.getElementById('lls-routine-was');
  var routineStepper = document.getElementById('lls-routine-stepper');
  var routineQtyVal = document.getElementById('lls-routine-qty-val');
  var routineQtyMark = document.getElementById('lls-routine-qty-mark');
  var compOn = false;
  var compVariant = 0, compPriceCents = 0, compFirst = 10, compFallbackPlan = '', compPrepaidPlan = '';
  if (routineEl) {
    compVariant = parseInt(routineEl.dataset.variant) || 0;
    compPriceCents = parseInt(routineEl.dataset.price) || 0;
    compFirst = parseInt(routineEl.dataset.first) || 10;
    compFallbackPlan = routineEl.dataset.fallbackPlan || '';
    compPrepaidPlan = routineEl.dataset.prepaidPlan || '';
  }
  function compIsPrepaid() {
    /* Mirror-the-main: the add-on rides the same model as the selected offer (3-pack -> prepaid, 1-tub -> ladder, one-time -> one-time). */
    return mode === 'sub' && prepaidOn && !!compPrepaidPlan;
  }
  function compPayPrice() {
    /* What the complement costs on THIS order, ALL units: prepaid = 3 units at 20% in one charge (mirrors the main), ladder = first-order sub price x adults, one-time = full price x its own stepper qty. */
    if (compIsPrepaid()) return Math.round(compPriceCents * 3 * 0.8) / 100;
    if (mode === 'sub') return Math.round(compPriceCents * (1 - compFirst / 100)) / 100 * qty;
    return compPriceCents / 100 * compQtyOt;
  }
  function updateRoutine() {
    if (!routineEl) return;
    var subMode = mode === 'sub';
    var isPreComp = compIsPrepaid();
    var cq = subMode ? (isPreComp ? 3 : qty) : compQtyOt; /* effective complement quantity */
    if (routineWasEl) {
      routineWasEl.style.display = subMode ? '' : 'none';
      if (subMode) routineWasEl.textContent = formatMoney(compPriceCents / 100 * cq);
    }
    if (routinePriceEl) routinePriceEl.textContent = '+' + formatMoney(compPayPrice());
    if (routineQtyMark) {
      /* Small "x N" marker: sub mode only (the mini stepper shows the count in one-time mode) */
      var showMark = subMode && cq > 1;
      routineQtyMark.style.display = showMark ? '' : 'none';
      if (showMark) routineQtyMark.textContent = 'x ' + cq;
    }
    if (routineStepper) routineStepper.classList.toggle('lls-m-otstep--hidden', subMode);
    if (routineQtyVal) routineQtyVal.textContent = compQtyOt;
  }

  var ctaBtn = document.getElementById('lls-cta-btn');
  var ctaText = document.getElementById('lls-cta-text');
  var ctaCompare = document.getElementById('lls-cta-compare');
  var ctaPrice = document.getElementById('lls-cta-price');
  var vsEl = document.getElementById('lls-vs');
  var vsSave = document.getElementById('lls-vs-save');
  var GIFT_VALUE = C.giftValueCents / 100, SHIP_VALUE = 4.00; /* market-currency chews value + flat 4.00 shipping */
  var qtyHidden = document.getElementById('lls-qty-hidden');
  var sellingPlanHidden = document.getElementById('lls-selling-plan-hidden');
  var stickyPrice = document.getElementById('lls-sticky-price');
  var stickyAtcBtn = document.getElementById('lls-sticky-atc');

  function formatMoney(amount) {
    return currencySymbol + amount.toFixed(2);
  }

  function updatePrices() {
    /* One-time card: displayed price follows its own stepper quantity (unit x qtyOt). Adults pills control subscribe qty only. */
    subCards.forEach(function(card) {
      if (card.dataset.plan !== 'onetime') return;
      var cardTotal = Math.round(basePriceCents * qtyOt) / 100;
      var priceEl = card.querySelector('[data-role="price"]');
      if (priceEl) priceEl.textContent = formatMoney(cardTotal);
      if (otQtyVal) otQtyVal.textContent = qtyOt;
      var servingEl = card.querySelector('[data-role="per-serving"]');
      if (servingEl) servingEl.textContent = formatMoney(basePrice / servings) + '/day';
      /* Toggle shipping note based on price threshold */
      var shippingNote = card.querySelector('[data-role="onetime-shipping"]');
      if (shippingNote) shippingNote.style.display = cardTotal < 50 ? '' : 'none';
    });

    /* Per-day line under the title is selection-aware: set in updateCTA, not here. */
  }

  function updateCTA() {
    if (!ctaBtn) return;
    var c = cadObj(cad);
    updateRoutine();

    if (mode === 'sub' && c) {
      var first = c.first || 10;
      var fin = c.final || 20;
      var mid = ladderData.mid || 15;
      var isPre = !!(prepaidOn && prepaidData);
      var unitPrice, mainTotal, mainCompare, planIdForCart;
      if (isPre) {
        /* Prepaid 3-pack: 20% flat on all 3 units, one charge, quantity 1 (variant-safe: computed from the live base price; Loop's fixed plan price is derived the same way) */
        unitPrice = Math.round(basePriceCents * 0.8) / 100;
        mainTotal = Math.round(basePriceCents * 3 * 0.8) / 100;
        mainCompare = basePrice * 3;
        planIdForCart = prepaidData.id;
      } else {
        unitPrice = Math.round(basePriceCents * (1 - first / 100)) / 100;
        mainTotal = unitPrice * qty;
        mainCompare = basePrice * qty;
        planIdForCart = c.id;
      }
      /* CTA price/compare include the optional complement when toggled on */
      var totalPrice = mainTotal, totalCompare = mainCompare;
      if (routineEl && compOn) {
        totalPrice = mainTotal + compPayPrice();
        totalCompare = mainCompare + compPriceCents / 100 * (compIsPrepaid() ? 3 : qty); /* add-on mirrors the main: 3 units prepaid, else 1 per delivery on its ladder plan */
      }

      if (ctaText) ctaText.textContent = 'ADD TO CART';
      if (ctaCompare) { ctaCompare.textContent = formatMoney(totalCompare); ctaCompare.style.display = 'inline'; }
      if (ctaPrice) ctaPrice.textContent = formatMoney(totalPrice);
      if (qtyHidden) qtyHidden.value = (isPre && bulkMode) ? 3 : 1; /* bulk: 3 tubs on a per-unit percentage plan */
      if (sellingPlanHidden) sellingPlanHidden.value = planIdForCart;

      /* Pack pill live prices (variant-safe) */
      var pill1Price = document.getElementById('lls-pill1-price');
      if (pill1Price) pill1Price.textContent = formatMoney(Math.round(basePriceCents * (1 - first / 100)) / 100);
      var pill3Per = document.getElementById('lls-pill3-per');
      if (pill3Per) pill3Per.innerHTML = formatMoney(Math.round(basePriceCents * 0.8) / 100) + '<small>/' + unitLabel + '</small>';
      var pill3Full = document.getElementById('lls-pill3-full');
      if (pill3Full) pill3Full.textContent = formatMoney(Math.round(basePriceCents * 3 * 0.8) / 100) + ' total';
      var pill1Was = document.getElementById('lls-pill1-was');
      if (pill1Was) pill1Was.textContent = formatMoney(basePrice);
      var pill3Was = document.getElementById('lls-pill3-was');
      if (pill3Was) pill3Was.textContent = formatMoney(basePrice);
      var hintPre = document.getElementById('lls-hint-pre');
      if (hintPre) hintPre.textContent = formatMoney(Math.round(basePriceCents * 0.8) / 100) + '/' + unitLabel;
      var hintLad = document.getElementById('lls-hint-lad');
      if (hintLad) hintLad.textContent = formatMoney(Math.round(basePriceCents * (1 - first / 100)) / 100);
      /* Per-month value lines (shown only when the unit lasts > 1 month; variant-safe, incl. per-variant supply) */
      var permoMonths = ladderData.monthsPerTub || 1;
      var pill3Mo = document.getElementById('lls-pill3-mo');
      if (pill3Mo) {
        pill3Mo.style.display = permoMonths > 1 ? '' : 'none';
        pill3Mo.textContent = formatMoney(Math.round(basePriceCents * 0.8 / permoMonths) / 100) + '/mo';
      }
      var pill1Mo = document.getElementById('lls-pill1-mo');
      if (pill1Mo) {
        pill1Mo.style.display = permoMonths > 1 ? '' : 'none';
        pill1Mo.textContent = formatMoney(Math.round(basePriceCents * (1 - first / 100) / permoMonths) / 100) + '/mo';
      }
      var otLinkPrice = oneTimeCard ? oneTimeCard.querySelector('[data-role="price"]') : null;
      if (otLinkPrice) otLinkPrice.textContent = formatMoney(basePrice);

      /* Per-day line under the title follows the selected offer: per-unit price at today's discount (20% flat prepaid, first-delivery % on the ladder) */
      var perDayEl = document.getElementById('lls-per-serving-value');
      if (perDayEl && servings) perDayEl.textContent = formatMoney(unitPrice / servings);

      /* Standalone hero price row (main product only): tag left, struck compare + big price right */
      var subPriceEl = document.getElementById('lls-sub-price');
      var subCompareEl = document.getElementById('lls-sub-compare');
      var priceTagEl = document.querySelector('.lls-m-subprice [data-role="price-tag"]');
      if (subPriceEl) subPriceEl.textContent = formatMoney(mainTotal);
      if (subCompareEl) subCompareEl.textContent = formatMoney(mainCompare);
      if (priceTagEl) priceTagEl.textContent = isPre ? 'Save 20% on all 3' : ('Save ' + first + '% today');

      /* Grow line + ladder strip swap between ladder and prepaid */
      var growEl = document.querySelector('.lls-m-subprice__grow');
      if (growEl) growEl.textContent = isPre
        ? (bulkMode ? '20% locked in from day one.' : '20% locked in from day one, all paid today.')
        : ('Then ' + fin + '% off for life from your second delivery.');
      var stripEl = document.getElementById('lls-ladder-strip');
      var capEl = document.querySelector('.lls-m-ladder__cap');
      if (stripEl) stripEl.style.display = isPre ? 'none' : '';
      if (capEl) capEl.style.display = isPre ? 'none' : '';

      /* Ladder journey strip: three live price cells (main product only) */
      var p2 = Math.round(basePriceCents * (1 - mid / 100)) / 100 * qty;
      var p3 = Math.round(basePriceCents * (1 - fin / 100)) / 100 * qty;
      var ladP1 = document.getElementById('lls-lad-p1');
      var ladP2 = document.getElementById('lls-lad-p2');
      var ladP3 = document.getElementById('lls-lad-p3');
      if (ladP1) ladP1.textContent = formatMoney(mainTotal);
      if (ladP2) ladP2.textContent = formatMoney(p2);
      if (ladP3) ladP3.textContent = formatMoney(p3);
      var ladderFirstEl = document.querySelector('#lls-ladder-strip [data-role="ladder-first"]');
      var ladderMidEl = document.querySelector('#lls-ladder-strip [data-role="ladder-mid"]');
      var ladderFinalEl = document.querySelector('#lls-ladder-strip [data-role="ladder-final"]');
      if (ladderFirstEl) ladderFirstEl.textContent = first + '% off';
      if (ladderMidEl) ladderMidEl.textContent = mid + '% off';
      if (ladderFinalEl) ladderFinalEl.textContent = fin + '% off';

      /* Value stack: badge only, "You save £X today" (RRP x qty + complement RRP when on + free gifts, minus price paid) */
      if (vsEl) {
        var vsTotalValue = totalCompare + ((prepaidOn && prepaidData) ? GIFT_VALUE : 0) + SHIP_VALUE; /* single tub: gift ships with the 2nd delivery, so not "today" */
        var vsSaveAmt = vsTotalValue - totalPrice;
        if (vsSaveAmt > 0) {
          if (vsSave) vsSave.textContent = 'You save ' + formatMoney(vsSaveAmt) + ' today';
          vsEl.style.display = '';
        } else { vsEl.style.display = 'none'; }
      }

      /* Update sticky bar (toggle active state mirrors the accordion; 3-pack option hides when the variant has no bulk/prepaid plan) */
      if (stickyAtcBtn) stickyAtcBtn.textContent = C.ctaText + ' - ' + formatMoney(totalPrice);
      if (stickyPrice) stickyPrice.textContent = formatMoney(unitPrice) + '/' + unitLabel;
      var sp3 = document.getElementById('lls-sticky-plan3');
      var sp1 = document.getElementById('lls-sticky-plan1');
      if (sp3) {
        sp3.style.display = (prepaidOn || prepaidData) ? '' : 'none';
        sp3.classList.toggle('lls-m-sticky-bar__plan--on', isPre);
      }
      if (sp1) sp1.classList.toggle('lls-m-sticky-bar__plan--on', !isPre);
    } else {
      var oneTotal = Math.round(basePriceCents * qtyOt) / 100;
      if (routineEl && compOn) oneTotal = oneTotal + compPriceCents / 100 * compQtyOt;
      if (ctaText) ctaText.textContent = 'ADD TO CART';
      if (ctaCompare) ctaCompare.style.display = 'none';
      if (ctaPrice) ctaPrice.textContent = formatMoney(oneTotal);
      if (qtyHidden) qtyHidden.value = qtyOt;
      if (sellingPlanHidden) sellingPlanHidden.value = '';
      if (vsEl) vsEl.style.display = 'none';
      var otLinkPrice2 = oneTimeCard ? oneTimeCard.querySelector('[data-role="price"]') : null;
      if (otLinkPrice2) otLinkPrice2.textContent = formatMoney(basePrice);

      /* No subscription selected (plan-less products): per-day from the one-time price */
      var perDayEl2 = document.getElementById('lls-per-serving-value');
      if (perDayEl2 && servings) perDayEl2.textContent = formatMoney(basePrice / servings);

      /* Update sticky bar */
      if (stickyAtcBtn) stickyAtcBtn.textContent = 'ADD TO CART - ' + formatMoney(oneTotal);
      if (stickyPrice) stickyPrice.textContent = formatMoney(basePrice);
    }
  }

  function updateDeliveryLine() {
    /* Fixed matched-cadence delivery copy: what ships, how often, and why. */
    if (!deliveryLine) return;
    var every = cad === 1 ? 'month' : cad + ' months';
    if (prepaidOn && prepaidData && bulkMode) {
      deliveryLine.textContent = '3 ' + unitLabelPlural + ' delivered together every ' + (cad * 3) + ' months. 20% off every delivery.';
    } else if (prepaidOn && prepaidData) {
      deliveryLine.textContent = '3 ' + unitLabelPlural + ' paid today, 1 delivered every ' + every + '. Renews after your 3rd delivery.';
    } else {
      deliveryLine.textContent = '1 ' + unitLabel + ' delivered every ' + every + ', matched to how long it lasts.';
    }
  }

  function renderSelection() {
    var subActive = mode === 'sub';
    /* Accordion cards: selected expands + goes mint; the other collapses to its head row */
    if (accPre) {
      var preOn = subActive && prepaidOn;
      accPre.classList.toggle('lls-m-acc--on', preOn);
      accPre.setAttribute('aria-expanded', preOn ? 'true' : 'false');
    }
    if (accLad) {
      var ladOn = subActive && !prepaidOn;
      accLad.classList.toggle('lls-m-acc--on', ladOn);
      accLad.setAttribute('aria-expanded', ladOn ? 'true' : 'false');
    }
    if (oneTimeCard) oneTimeCard.classList.toggle('lls-m-otlink--on', !subActive);
    updateDeliveryLine();
  }

  /* ── Event Listeners ── */
  function setAdults(n) {
    prepaidOn = (n === 3 && !!prepaidData);
    qty = 1; /* prepaid bills 3 deliveries on a single line at quantity 1; ladder is 1 unit per delivery */
    mode = 'sub'; /* picking an offer card implies subscribing */
    renderSelection();
    updatePrices();
    updateCTA();
  }
  if (accPre) { accPre.addEventListener('click', function() { setAdults(3); }); }
  if (accLad) { accLad.addEventListener('click', function() { setAdults(1); }); }
  function llsOpenDrawer() {
    if (typeof Boost !== 'undefined' && Boost.Cart) {
      if (typeof Boost.Cart.refresh === 'function') Boost.Cart.refresh();
      if (typeof Boost.Cart.open === 'function') Boost.Cart.open();
      else { var ci = document.querySelector('#cart-icon-bubble'); if (ci) ci.click(); }
    } else { var ci2 = document.querySelector('#cart-icon-bubble'); if (ci2) ci2.click(); }
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e){}
  }
  function llsAddErrMsg() {
    var w = document.querySelector('.lls-m-cta-wrap') || (ctaBtn && ctaBtn.parentNode);
    if (!w) return;
    var el = document.getElementById('lls-add-err');
    if (!el) { el = document.createElement('div'); el.id = 'lls-add-err'; el.style.cssText = 'margin-top:10px;text-align:center;font-size:13px;font-weight:700;color:#b3261e;'; w.appendChild(el); }
    el.textContent = 'Sorry - something went wrong adding to your cart. Please try again.';
    clearTimeout(el.__t); el.__t = setTimeout(function(){ el.textContent = ''; }, 6000);
  }
  /* Failure fallback: NEVER navigate away (Ben's rule: the cart page is never shown).
     Retry the PAID item alone (gift/add-on are best-effort extras), open the drawer on
     success; only if even that fails, show an inline error next to the CTA. */
  function llsAddFallback(items, err) {
    console.error('LLS cart add error:', err);
    if (items && items.length > 1) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [items[0]] }) })
        .then(function(r){ if (!r.ok) { throw new Error('retry failed'); } return r.json(); })
        .then(function(){ llsOpenDrawer(); })
        .catch(function(){ llsAddErrMsg(); });
    }
    llsAddErrMsg();
  }
  function llsCartAdd(items, busyEl) {
    /* Shared ajax add + Boost drawer open (same feedback path as the subscription CTA). */
    if (busyEl) { busyEl.style.pointerEvents = 'none'; busyEl.style.opacity = '0.6'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) { var e = new Error(j && j.description ? j.description : 'Cart add failed'); throw e; } return j; }); })
      .then(function(res){
        if (busyEl) { busyEl.style.pointerEvents = ''; busyEl.style.opacity = ''; }
        llsOpenDrawer();
        return res;
      })
      .catch(function(err){
        if (busyEl) { busyEl.style.pointerEvents = ''; busyEl.style.opacity = ''; }
        llsAddFallback(items, err);
      });
  }
  if (oneTimeCard) {
    oneTimeCard.addEventListener('click', function() {
      /* The link IS the one-time add: it puts 1 unit at full price straight in the cart
         (plus the add-on as a one-time unit when toggled) and opens the drawer.
         It does NOT change the box state - the big CTA stays subscription-only. */
      if (ctaBtn && ctaBtn.disabled) return; /* variant unavailable */
      var vIn2 = document.querySelector('#lls-m-product-form .product-variant-id');
      if (!vIn2 || !vIn2.value) return;
      var items = [{ id: Number(vIn2.value), quantity: 1 }];
      if (routineEl && compOn && compVariant) items.push({ id: compVariant, quantity: 1, properties: { _lls_src: 'pdp-routine' } });
      llsCartAdd(items, oneTimeCard);
    });
  }
  if (otStepper) {
    otStepper.querySelectorAll('.lls-m-otstep__btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        qtyOt = Math.min(10, Math.max(1, qtyOt + (parseInt(btn.dataset.step) || 0)));
        mode = 'onetime'; /* using the one-time stepper implies a one-time purchase */
        renderSelection();
        updatePrices();
        updateCTA();
      });
    });
  }
  if (routineToggle) {
    routineToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      compOn = !compOn;
      routineToggle.classList.toggle('lls-m-routine__toggle--on', compOn);
      routineToggle.setAttribute('aria-checked', compOn ? 'true' : 'false');
      updateCTA();
    });
  }
  if (routineStepper) {
    routineStepper.querySelectorAll('.lls-m-otstep__btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        compQtyOt = Math.min(10, Math.max(1, compQtyOt + (parseInt(btn.dataset.step) || 0)));
        updateCTA(); /* updateRoutine runs inside updateCTA */
      });
    });
  }
  var routineWhy = document.getElementById('lls-routine-why');
  var routineReason = document.getElementById('lls-routine-reason');
  if (routineWhy && routineReason) {
    routineWhy.addEventListener('click', function(e) {
      e.stopPropagation();
      routineReason.style.display = routineReason.style.display === 'none' ? '' : 'none';
    });
  }



  /* ── Image Gallery ── */
  var imageUrls = (C.images || []).slice();
  var currentIndex = 0;
  var mainImg = document.getElementById('lls-main-image');
  var thumbs = document.querySelectorAll('.lls-m-gallery__thumb');
  var prevBtn = document.getElementById('lls-prev-btn');
  var nextBtn = document.getElementById('lls-next-btn');
  var carousel = document.getElementById('lls-carousel');
  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  /* Scroll ONLY the given horizontal strip to reveal el. scrollIntoView also scrolls every
     scrollable ANCESTOR (including the page body when anything overflows the viewport), which
     shifted the whole page left on mobile when far-right flavour thumbs were centred. */
  function scrollStripTo(container, el, align) {
    if (!container || !el) return;
    var cr = container.getBoundingClientRect();
    var er = el.getBoundingClientRect();
    var target = (er.left - cr.left) + container.scrollLeft;
    if (align === 'center') target -= (container.clientWidth - er.width) / 2;
    target = Math.max(0, target);
    try { container.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) { container.scrollLeft = target; }
  }

  function setImage(idx) {
    if (idx < 0) idx = imageUrls.length - 1;
    if (idx >= imageUrls.length) idx = 0;
    currentIndex = idx;
    if (mainImg) { if (mainImg.hasAttribute('srcset')) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); } mainImg.src = imageUrls[idx]; } /* lls-speed-20261017 */
    thumbs.forEach(function(t, i) {
      t.classList.toggle('lls-m-gallery__thumb--active', i === idx);
    });
    /* Auto-scroll thumbnail strip (strip only, never the page) to keep active thumb visible */
    var activeThumb = document.querySelector('.lls-m-gallery__thumb--active');
    if (activeThumb) {
      scrollStripTo(document.getElementById('lls-thumbs'), activeThumb, 'center');
    }
    /* Mobile shows the scroll-snap CAROUSEL, not #lls-main-image: scroll it to the slide too,
       so variant selection (and prev/next) actually changes the visible image on mobile. */
    if (isMobile && carousel && carousel.children[idx]) {
      scrollStripTo(carousel, carousel.children[idx], 'start');
    }
  }

  /* Desktop: thumbnail clicks + arrow buttons */
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var idx = parseInt(this.dataset.index);
      setImage(idx); /* setImage scrolls the mobile carousel itself */
    });
  });
  if (prevBtn) prevBtn.addEventListener('click', function() { setImage(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { setImage(currentIndex + 1); });

  /* ── Mobile: Scroll-snap carousel sync + dynamic height ── */
  if (isMobile && carousel) {
    var scrollTimeout;

    /* Dynamically set carousel height to match the currently visible slide */
    function updateCarouselHeight(idx) {
      var slides = carousel.querySelectorAll('.lls-m-gallery__slide');
      if (slides[idx]) {
        var slideImg = slides[idx].querySelector('img');
        if (slideImg && slideImg.complete && slideImg.naturalHeight > 0) {
          var displayedHeight = slideImg.offsetHeight;
          carousel.style.height = displayedHeight + 'px';
        } else if (slideImg) {
          /* Image not loaded yet, wait for it */
          slideImg.addEventListener('load', function() {
            if (currentIndex === idx) {
              carousel.style.height = slideImg.offsetHeight + 'px';
            }
          }, { once: true });
        }
      }
    }

    /* Set initial height once first image loads */
    var firstSlideImg = carousel.querySelector('.lls-m-gallery__slide img');
    if (firstSlideImg) {
      if (firstSlideImg.complete) {
        updateCarouselHeight(0);
      } else {
        firstSlideImg.addEventListener('load', function() {
          updateCarouselHeight(0);
        }, { once: true });
      }
    }

    carousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        /* Determine which slide is most visible */
        var slides = carousel.querySelectorAll('.lls-m-gallery__slide');
        var carouselLeft = carousel.scrollLeft;
        var carouselWidth = carousel.offsetWidth;
        var bestIdx = 0;
        var bestOverlap = 0;
        slides.forEach(function(slide, i) {
          var slideLeft = slide.offsetLeft - carousel.offsetLeft;
          var slideRight = slideLeft + slide.offsetWidth;
          var visibleLeft = Math.max(slideLeft, carouselLeft);
          var visibleRight = Math.min(slideRight, carouselLeft + carouselWidth);
          var overlap = Math.max(0, visibleRight - visibleLeft);
          if (overlap > bestOverlap) {
            bestOverlap = overlap;
            bestIdx = i;
          }
        });
        if (bestIdx !== currentIndex) {
          currentIndex = bestIdx;
          thumbs.forEach(function(t, i) {
            t.classList.toggle('lls-m-gallery__thumb--active', i === bestIdx);
          });
          var activeThumb = document.querySelector('.lls-m-gallery__thumb--active');
          if (activeThumb) {
            scrollStripTo(document.getElementById('lls-thumbs'), activeThumb, 'center');
          }
          /* Update carousel height for the new active slide */
          updateCarouselHeight(bestIdx);
        }
      }, 80);
    }, { passive: true });
  }

  /* ── Lightbox: tap to enlarge ── */
  (function() {
    var lb = document.createElement('div');
    lb.className = 'lls-m-lightbox';
    lb.innerHTML = '<button class="lls-m-lightbox__close" aria-label="Close">&times;</button>'
      + '<button class="lls-m-lightbox__nav lls-m-lightbox__nav--prev" aria-label="Previous">&#8249;</button>'
      + '<img class="lls-m-lightbox__img" src="" alt="Product image" />'
      + '<button class="lls-m-lightbox__nav lls-m-lightbox__nav--next" aria-label="Next">&#8250;</button>'
      + '<div class="lls-m-lightbox__counter"></div>';
    document.body.appendChild(lb);

    var lbImg = lb.querySelector('.lls-m-lightbox__img');
    var lbCounter = lb.querySelector('.lls-m-lightbox__counter');
    var lbClose = lb.querySelector('.lls-m-lightbox__close');
    var lbPrev = lb.querySelector('.lls-m-lightbox__nav--prev');
    var lbNext = lb.querySelector('.lls-m-lightbox__nav--next');
    var lbIndex = 0;

    function openLightbox(idx) {
      lbIndex = idx;
      lbImg.src = imageUrls[idx];
      lbCounter.textContent = (idx + 1) + ' / ' + imageUrls.length;
      lb.classList.add('lls-m-lightbox--open');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      lb.classList.remove('lls-m-lightbox--open');
      document.body.style.overflow = '';
    }
    function lbNav(dir) {
      lbIndex += dir;
      if (lbIndex < 0) lbIndex = imageUrls.length - 1;
      if (lbIndex >= imageUrls.length) lbIndex = 0;
      lbImg.src = imageUrls[lbIndex];
      lbCounter.textContent = (lbIndex + 1) + ' / ' + imageUrls.length;
    }

    /* Desktop: click main image to open lightbox */
    if (mainImg) {
      mainImg.style.cursor = 'zoom-in';
      mainImg.addEventListener('click', function(e) {
        e.preventDefault();
        openLightbox(currentIndex);
      });
    }

    /* Mobile: click any carousel slide image to open lightbox */
    if (carousel) {
      var slideImgs = carousel.querySelectorAll('.lls-m-gallery__slide img');
      slideImgs.forEach(function(img, i) {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function(e) {
          e.preventDefault();
          openLightbox(i);
        });
      });
    }

    lbClose.addEventListener('click', closeLightbox);
    lb.addEventListener('click', function(e) { if (e.target === lb) closeLightbox(); });
    lbPrev.addEventListener('click', function(e) { e.stopPropagation(); lbNav(-1); });
    lbNext.addEventListener('click', function(e) { e.stopPropagation(); lbNav(1); });

    /* Keyboard nav */
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('lls-m-lightbox--open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lbNav(-1);
      if (e.key === 'ArrowRight') lbNav(1);
    });

    /* Swipe in lightbox */
    var lbTouchX = 0;
    lb.addEventListener('touchstart', function(e) { lbTouchX = e.changedTouches[0].screenX; }, { passive: true });
    lb.addEventListener('touchend', function(e) {
      var diff = e.changedTouches[0].screenX - lbTouchX;
      if (Math.abs(diff) > 50) {
        if (diff < 0) lbNav(1); else lbNav(-1);
      }
    }, { passive: true });
  })();

  /* ── Sticky Bar ── */
  var stickyBar = document.getElementById('lls-sticky-bar');
  var buybox = document.getElementById('lls-buybox');
  if (buybox && stickyBar) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) { stickyBar.style.display = entry.isIntersecting ? 'none' : 'block'; });
    }, { threshold: 0 });
    observer.observe(buybox);
  }

  /* Sticky plan toggle: drives the same selection state as the accordion cards */
  var stickyPlan3 = document.getElementById('lls-sticky-plan3');
  var stickyPlan1 = document.getElementById('lls-sticky-plan1');
  if (stickyPlan3) { stickyPlan3.addEventListener('click', function() { setAdults(3); }); }
  if (stickyPlan1) { stickyPlan1.addEventListener('click', function() { setAdults(1); }); }

  var stickyAtc = document.getElementById('lls-sticky-atc');
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function() {
      var cta = document.getElementById('lls-cta-btn');
      if (cta) { cta.click(); return; }
      var form = document.getElementById('lls-m-product-form');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true }));
    });
  }


  /* ── Bundle-only: fix qty > 1 for FastBundle Cart Transform products ── */
  /* FastBundle's Cart Transform forces qty:1 per add. For bundles needing
     qty > 1 (e.g. 3-month = 3 packs), we intercept the CTA click, add 1,
     then update qty via /cart/change.js. Single products are NOT affected. */
  if (isBundle && ctaBtn) {
    ctaBtn.addEventListener('click', function(e) {
      var qty = parseInt(qtyHidden.value) || 1;
      if (qty <= 1) return; /* qty:1 works fine, let default handler proceed */

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantInput = document.querySelector('#lls-m-product-form .product-variant-id');
      if (!variantInput) return;
      var variantId = variantInput.value;
      var sp = sellingPlanHidden ? sellingPlanHidden.value : '';

      /* Disable button while processing */
      ctaBtn.disabled = true;
      ctaBtn.style.opacity = '0.6';

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      if (sp) fd.append('selling_plan', sp);

      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function(r) { return r.json(); })
        .then(function(item) {
          /* Update quantity to the correct amount */
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: qty })
          });
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          /* Trigger Boost Cart drawer refresh */
          if (typeof Boost !== 'undefined' && Boost.Cart) {
            if (typeof Boost.Cart.refresh === 'function') Boost.Cart.refresh();
          }
          /* Open cart drawer */
          var cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) cartIcon.click();
        })
        .catch(function(err) {
          ctaBtn.disabled = false;
          ctaBtn.style.opacity = '';
          llsAddFallback(null, err);
        });
    }, true); /* useCapture = true to fire before product-form handler */
  }

  /* ── Subscription: add the free welcome gift (chews) in the SAME add-to-cart ── */
  /* Adds the subscription line + the free chews (one-time) in one /cart/add so the gift
     appears together with the product (no pop-in) and AFTER it in the cart. Free via the
     "Free welcome gift" BXGY auto-discount. Only fires when subscribing. */
  var giftForm = document.getElementById('lls-m-product-form');
  if (!isBundle && giftForm) {
    var GIFT_VARIANT_HERO = C.giftVariant; /* GBP: Creapure Creatine Chews 35 Tablets; other markets: the US gift (no US chews stock, Ben 2026-08-13). Same branch in snippets/lls-gift-manager.liquid. */
    /* Intercept the ATC click in CAPTURE (document) so we add the subscription + gift atomically,
       before <product-form>/Boost handle the submit. preventDefault on the click stops the submit. */
    document.addEventListener('click', function(e) {
      var clicked = (e.target && e.target.closest) ? e.target.closest('#lls-cta-btn') : null;
      if (!clicked) return; /* only the main Add to Cart button */
      var sp = sellingPlanHidden ? sellingPlanHidden.value : '';
      var wantComp = !!(routineEl && compOn && compVariant);
      var vIn = giftForm.querySelector('.product-variant-id');
      if (!vIn || !vIn.value) return;
      if (String(vIn.value) === String(GIFT_VARIANT_HERO)) return; /* not on the chews PDP itself */
      /* ALL adds go through this one path (subs, one-time, with/without complement): the theme's
         default <product-form> handler expects the native cart drawer, which Boost replaced, so it
         adds with no visible feedback. Here we add via /cart/add.js and open the Boost drawer ourselves. */
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var qv = parseInt(qtyHidden && qtyHidden.value) || 1;
      var props = {};
      giftForm.querySelectorAll('input[name^="properties["]').forEach(function(inp){
        var mm = inp.name.match(/^properties\[(.+)\]$/); if (mm) props[mm[1]] = inp.value;
      });
      var items = [];
      if (sp) {
        items.push({ id: Number(vIn.value), quantity: qv, selling_plan: Number(sp), properties: props });
        if (wantComp) {
          /* Mirror-the-main: 3-pack main -> complement on ITS 3-pack plan (bulk: qty 3 on the percentage plan; prepaid: qty 1, 3 deliveries in the plan); ladder main -> complement on its own supply-matched ladder plan. */
          var mirrorPre = prepaidOn && compPrepaidPlan;
          var compSp = mirrorPre ? compPrepaidPlan : compFallbackPlan;
          var compQ = mirrorPre ? (bulkMode ? 3 : 1) : qty;
          if (compSp) { items.push({ id: compVariant, quantity: compQ, selling_plan: Number(compSp), properties: { _lls_src: 'pdp-routine' } }); }
          else { items.push({ id: compVariant, quantity: compQ, properties: { _lls_src: 'pdp-routine' } }); }
        }
        if (prepaidOn && prepaidData) items.push({ id: GIFT_VARIANT_HERO, quantity: 1, properties: { _gift: '1' } }); /* 2026-10-15: checkout gift = 3-pack only; single tub gets it on delivery 2 */
      } else {
        /* One-time purchase: no plans, no gift. Complement (when toggled) qty from its mini stepper. */
        items.push({ id: Number(vIn.value), quantity: qv, properties: props });
        if (wantComp) { items.push({ id: compVariant, quantity: compQtyOt, properties: { _lls_src: 'pdp-routine' } }); } /* 2026-10-20: _lls_src tags measure the routine row */
      }
      if (ctaBtn) { ctaBtn.disabled = true; ctaBtn.style.opacity = '0.6'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) { var e = new Error(j && j.description ? j.description : 'Cart add failed'); throw e; } return j; }); })
        .then(function(){
          if (ctaBtn) { ctaBtn.disabled = false; ctaBtn.style.opacity = ''; }
          llsOpenDrawer();
        })
        .catch(function(err){
          if (ctaBtn) { ctaBtn.disabled = false; ctaBtn.style.opacity = ''; }
          llsAddFallback(items, err);
        });
    }, true); /* capture: fire before product-form/Boost handler */
  }

  /* ── Variant Selector ── */
  var variantBtns = document.querySelectorAll('.lls-m-variant-btn');
  var selectedOptions = {};

  /* Initialise selectedOptions from the current active buttons */
  variantBtns.forEach(function(btn) {
    if (btn.classList.contains('lls-m-variant-btn--active')) {
      selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
    }
  });

  function findVariantByOptions() {
    return productVariants.find(function(v) {
      return productOptions.every(function(optName, idx) {
        var pos = String(idx + 1);
        return v.options[idx] === selectedOptions[pos];
      });
    });
  }

  function onVariantChange(variant) {
    if (!variant) return;

    /* Update hidden variant input */
    var variantInput = document.querySelector('#lls-m-product-form .product-variant-id');
    if (variantInput) {
      variantInput.value = variant.id;
      variantInput.disabled = !variant.available;
    }

    /* Update base price and recalculate everything */
    basePriceCents = variant.price;
    basePrice = basePriceCents / 100;

    /* Prepaid plan is PER VARIANT (Loop keeps one fixed-price group per variant): swap in this
       variant's plan id so the add never sends another variant's plan (422). If this variant has
       no prepaid plan, hide the 3-pack card and fall back to the ladder selection. */
    prepaidData = variant.prepaid || null;
    if (accPre) accPre.style.display = prepaidData ? '' : 'none';
    if (!prepaidData && prepaidOn) { prepaidOn = false; renderSelection(); }

    /* Flavour note follows the selected variant (variant metafield custom.flavour_note) */
    var flavNoteEl = document.getElementById('lls-flav-note');
    if (flavNoteEl) {
      var flavNote = variant.flavNote || '';
      flavNoteEl.textContent = flavNote;
      flavNoteEl.style.display = flavNote ? '' : 'none';
    }
    /* Servings line follows the variant too (variant metafield custom.capsules_servings) */
    var servTextEl = document.getElementById('lls-servings-text');
    if (servTextEl && variant.capsServ) { servTextEl.textContent = variant.capsServ; }

    /* Supply is also PER VARIANT (variant metafield custom.months_supply, e.g. Electrolyte
       Balance 120 caps = 2 months vs 60 caps = 1): recompute the matched cadence so the ladder
       plan, card titles, sentences, servings and delivery line all follow the selected variant. */
    if (variant.monthsPerTub && variant.monthsPerTub !== ladderData.monthsPerTub) {
      ladderData.monthsPerTub = variant.monthsPerTub;
      servings = variant.monthsPerTub * 30;
      cad = matchedCad();
      var supply3El = document.getElementById('lls-supply3');
      if (supply3El) supply3El.textContent = variant.monthsPerTub * 3;
      var supply1El = document.getElementById('lls-supply1');
      if (supply1El) supply1El.textContent = variant.monthsPerTub;
      var cadWord = cad === 1 ? 'month' : (cad + ' months');
      document.querySelectorAll('.lls-cadword').forEach(function(el){ el.textContent = cadWord; });
      document.querySelectorAll('.lls-cadword3').forEach(function(el){ el.textContent = (cad * 3) + ' months'; }); /* bulk 3-pack card cadence = 3x supply */
      updateDeliveryLine();
    }

    updatePrices();
    updateCTA();

    /* Update CTA disabled/sold-out state */
    if (ctaBtn) {
      ctaBtn.disabled = !variant.available;
      if (!variant.available) {
        ctaBtn.innerHTML = 'SOLD OUT';
      } else {
        /* Restore button inner structure if it was previously set to SOLD OUT */
        if (!document.getElementById('lls-cta-text')) {
          ctaBtn.innerHTML = '<span id="lls-cta-text"></span><span class="lls-m-cta-btn__prices"><span class="lls-m-cta-btn__compare" id="lls-cta-compare"></span><span id="lls-cta-price"></span></span>';
          /* Re-assign references */
          ctaText = document.getElementById('lls-cta-text');
          ctaPrice = document.getElementById('lls-cta-price');
          ctaCompare = document.getElementById('lls-cta-compare');
        }
        updateCTA();
      }
    }

    /* Switch image to variant's featured image */
    if (variant.featured_image) {
      setImage(variant.featured_image.position);
    }

    /* Update URL without reload */
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    /* ── Bundle: sync Rebundle's hidden component selects ── */
    if (isBundle) {
      var rbrContainer = document.getElementById('rbr-container-element-true');
      if (rbrContainer) {
        /* Extract the flavour from the variant title.
           e.g. "Daily Essentials Bundle - Watermelon" → "Watermelon"
           e.g. "Daily Essentials Bundle - Orange & Lime" → "Orange & Lime" */
        var flavour = variant.title;
        var dashIdx = flavour.lastIndexOf(' - ');
        if (dashIdx > -1) flavour = flavour.substring(dashIdx + 3).trim();

        /* Find all selects inside Rebundle and try to match the flavour */
        var rbrSelects = rbrContainer.querySelectorAll('select');
        rbrSelects.forEach(function(sel) {
          for (var i = 0; i < sel.options.length; i++) {
            var optText = sel.options[i].text.trim();
            /* Match flavour name (case-insensitive, handle "Orange and Lime" vs "Orange & Lime") */
            var normFlavour = flavour.toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ');
            var normOpt = optText.toLowerCase().replace(/&/g, 'and').replace(/\s+/g, ' ');
            if (normOpt === normFlavour || normOpt.indexOf(normFlavour) > -1 || normFlavour.indexOf(normOpt) > -1) {
              sel.value = sel.options[i].value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        });
      }
    }
  }

  variantBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var pos = btn.dataset.optionPosition;
      var val = btn.dataset.optionValue;

      /* Update active state for this option group. Flavour pills also get their background
         set inline: Chromium doesn't reliably repaint background from the
         .lls-m-variant-btn--active[data-flav] { background: var(--flav) } rule on class
         toggle (the ::before tick from the same selector DOES update), so JS is authoritative
         for the fill and CSS handles dot/tick/typography. */
      var group = btn.closest('.lls-m-variant-options');
      if (group) {
        group.querySelectorAll('.lls-m-variant-btn').forEach(function(b) {
          b.classList.remove('lls-m-variant-btn--active');
          if (b.hasAttribute('data-flav')) { b.style.background = '#fff'; }
        });
      }
      btn.classList.add('lls-m-variant-btn--active');
      if (btn.hasAttribute('data-flav')) { btn.style.background = btn.style.getPropertyValue('--flav').trim(); }

      /* Update selected options and find matching variant */
      selectedOptions[pos] = val;
      var matchedVariant = findVariantByOptions();
      if (matchedVariant) {
        onVariantChange(matchedVariant);
      }
    });
  });

  /* ── Hide Rebundle product list for bundles ── */
  if (isBundle) {
    function hideRebundleList() {
      var rbrEl = document.getElementById('rbr-container-element-true');
      if (rbrEl) {
        rbrEl.style.display = 'none';
        return true;
      }
      return false;
    }
    /* Try immediately, then observe for late injection */
    if (!hideRebundleList()) {
      var rbrObserver = new MutationObserver(function(mutations, obs) {
        if (hideRebundleList()) obs.disconnect();
      });
      rbrObserver.observe(document.body, { childList: true, subtree: true });
      /* Safety timeout: stop observing after 15s */
      setTimeout(function() { rbrObserver.disconnect(); }, 15000);
    }
  }

  /* ── Init ── */
  updatePrices();
  renderSelection();
  updateCTA();
});

